import { combineReducers } from 'redux';

import { getUserDataFromToken } from '@/utils/user';

import types from './types';

const initialState = {
  isLoading: false,
  error: null,
  data: {},
};

function authReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.HANDLE_LOGIN_REQUEST:
    case types.HANDLE_REFRESH_TOKEN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.HANDLE_LOGIN_FAILURE:
    case types.HANDLE_REFRESH_TOKEN_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.HANDLE_LOGIN_SUCCESS:
    case types.HANDLE_REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...payload,
          ...getUserDataFromToken(payload),
        },
      };
    case types.HANDLE_LOGOUT:
      return initialState;
    case types.LOAD_USER_FROM_TOKEN:
      return {
        ...state,
        data: {
          ...getUserDataFromToken(payload.token),
        },
      };
    default:
      return state;
  }
}

const forgotPasswordInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function forgotPasswordReducer(state = forgotPasswordInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.FORGOT_PASSWORD_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.FORGOT_PASSWORD_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.FORGOT_PASSWORD_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const recoverPasswordInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function recoverPasswordReducer(state = recoverPasswordInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.RECOVER_PASSWORD_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.RECOVER_PASSWORD_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.RECOVER_PASSWORD_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

export default combineReducers({
  login: authReducer,
  forgotPassword: forgotPasswordReducer,
  recoverPassword: recoverPasswordReducer,
});
